import * as React from "react";
import { DateFilter } from '../DateFilter';
import { Loader } from '../Loader';
import { injectIntl } from "react-intl";
import { TranslateText } from '../TranslateText';

// Typescript definition
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Information Widget component with props and its types
const _InformationWidget = props => {
  const {
    loader,
    image,
    imageAlt,
    imageTooltip,
    title,
    value,
    width,
    imageSize,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat,
    disabled
  } = props;
  const mapImageSize = {
    small: "kc-ui-sm-image",
    medium: "kc-ui-md-image",
    large: "kc-ui-xl-image"
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-information ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: "kc-ui-datefilter-div",
          children: dateFilter && /*#__PURE__*/_jsx(DateFilter, {
            title: dateFilterTitle,
            options: dateFilterOptions,
            value: dateFilterValue,
            onTriggerChange: onTriggerDateFilterChange,
            dateFormat: dateFilterDateFormat
          })
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "kc-ui-info-wrapper",
            children: [image ? /*#__PURE__*/_jsx("div", {
              className: `kc-ui-img-hide ${image && "kc-ui-status-icon"}`,
              children: /*#__PURE__*/_jsx("img", {
                src: image,
                alt: imageAlt,
                title: imageTooltip,
                className: mapImageSize[imageSize]
              })
            }) : null, /*#__PURE__*/_jsx("div", {
              className: "kc-ui-info-val",
              children: value && value.length && typeof value === "object" ? value.map((values, index) => {
                return /*#__PURE__*/_jsxs("div", {
                  className: "kc-ui-info-div",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "kc-ui-info-key",
                    style: values?.width ? {
                      width: `${values.width}`
                    } : {},
                    children: /*#__PURE__*/_jsx("ul", {
                      className: "kc-ui-nobullet",
                      children: /*#__PURE__*/_jsx("li", {
                        children: /*#__PURE__*/_jsx(TranslateText, {
                          id: values.label
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "kc-ui-info-value",
                    children: /*#__PURE__*/_jsx("ul", {
                      className: "kc-ui-nobullet",
                      children: /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsx(TranslateText, {
                          id: values.value
                        }), values?.score && values.score > 0 && values.score < 6 ? /*#__PURE__*/_jsx("img", {
                          className: "kc-ui-information-image",
                          src: require(`../resources/images/dot-rating${values.score}.png`)
                        }) : null]
                      })
                    })
                  })]
                }, index);
              }) : null
            })]
          })
        })]
      })
    })
  });
};
// Prop type defination for compile time

// Default props
_InformationWidget.defaultProps = {
  loader: false,
  image: "",
  imageAlt: "",
  imageTooltip: "",
  value: [],
  imageSize: "small",
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy",
  width: "100%",
  title: "",
  disabled: false
};
export const InformationWidget = injectIntl( /*#__PURE__*/React.memo(_InformationWidget));